export const Statuses = {
  1: "Kustutatud",
  2: "Suletud",
  3: "Aktiivne",
  4: "Uus",
  5: "Kinnitatud",
  6: "Arhiveeritud",
  7: "Probleemne"
}